import { bl_ppl_ap_inbox_queue_RowClass } from '../../../dbschema/bl_ppl_ap_inbox_queue.model';
import { BaseContainerModel } from '../../base-container.model';

export class PeppolAPInboxQueueContainerModel extends BaseContainerModel {
    bl_ppl_ap_inbox_queue: bl_ppl_ap_inbox_queue_RowClass = new bl_ppl_ap_inbox_queue_RowClass();
}